export const collegeAidProReferralLink =
  'https://mycap.collegeaidpro.com?refer=3fyu01V6zuBi';
export const collegeCountsAlabama529Link = 'https://www.collegecounts529.com/';
export const estimatedAidSourceLink =
  'https://nces.ed.gov/programs/digest/2021menu_tables.asp';
